<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/chJFH5/tc-custom/9781504010504.jpg?1728353267985" alt="This image is the cover for the book Exploits of Xenophon"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Exploits of Xenophon
      </h1>
      <p class="bookDescription body article font2">
        <b>Thousands of miles from home, one soldier leads an army to safety</b><br/><br/> The war with Sparta is over, and Athens is at peace for the first time in thirty years. Their Greek enemies subdued, the generals of Athens turn their eyes to the East, where the Persian Empire stretches to the edge of the known world. Never before have Greek soldiers marched into Persia. Xenophon will be among the first. A warrior whose bravery is matched only by his intelligence, Xenophon is a natural leader. When his army of ten thousand men is stranded far from home, it is up to him to lead them back to Greece without sacrificing the principles of democracy that they hold so dear.<br/>  <br/> A retelling of Xenophon’s classic <i>Anabasis</i>, this is a thrilling tale of bravery and survival, in which the mind is as valuable a weapon as the sword.<br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Geoffrey Household
      </h2>
      
      <p class="authorDescription body article">Geoffrey Household (1900&ndash;1988) was born in England. In 1922 he earned a bachelor of arts degree in English literature from the University of Oxford. After graduation, he worked at a bank in Romania before moving to Spain in 1926 and selling bananas as a marketing manager for the United Fruit Company.<BR /><BR /> In 1929 Household moved to the United States, where he wrote children&rsquo;s encyclopedia content and children&rsquo;s radio plays for CBS. From 1933 to 1939, he traveled internationally as a printer&rsquo;s-ink sales rep. During World War II, he served as an intelligence officer for the British army, with posts in Romania, Greece, Syria, Lebanon, and Persia. After the war, he returned to England and wrote full time until his death. He married twice, the second time in 1942 to Ilona Zsoldos-Gutm&aacute;n, with whom he had three children, a son and two daughters.<BR /><BR /> Household began writing in the 1920s and sold his first story to the <I>Atlantic Monthly</I> in 1936. His first novel, <I>The Terror of Villadonga</I>, was published during the same year. His first short story collection,&#160;<I>The Salvation of Pisco Gabar and Other Stories</I>, appeared in 1938. Altogether, Household wrote twenty-eight novels, including four for young adults; seven short story collections; and a volume of autobiography, <I>Against the Wind&#160;</I>(1958). Most of his novels are thrillers, and he is best known for&#160;<I>Rogue Male</I>&#160;(1939), which was filmed as&#160;<I>Man Hunt</I> in 1941 and as a TV movie under the novel&rsquo;s original title in 1976.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?686877e0